import React from "react";
import FormDataProvider from "integrations/contexts/FormDataProvider";
import { SidebarProvider } from "./context/Sidebar";
import { StepsProvider } from "./context/Steps";
import { AdvancedOptionsProvider } from "./context/AdvancedOptions";
import F5Networks from "./F5Networks";
import INITIAL_FORMDATA from "./_initialFormData";
const EmbeddedF5NetworksApp = () => /* @__PURE__ */ React.createElement(StepsProvider, null, /* @__PURE__ */ React.createElement(FormDataProvider, { initialFormData: INITIAL_FORMDATA }, /* @__PURE__ */ React.createElement(SidebarProvider, null, /* @__PURE__ */ React.createElement(AdvancedOptionsProvider, null, /* @__PURE__ */ React.createElement(F5Networks, { externalInputSubmit: false })))));
export default EmbeddedF5NetworksApp;
